import { AnsweredQuestionCopy } from '@mindfulchefuk/components/FAQ/FAQ.types'

export const FAQOnboardingCopy: AnsweredQuestionCopy[] = [
  {
    question: 'How does the subscription work?',
    answer:
      'After signing up and placing your first recipe box order, your weekly recipe box subscription will be activated. We offer a fully flexible subscription to suit your lifestyle, with no tie in or commitment. You can pause or cancel at any time and change your deliveries to fit around your schedule.',
  },
  {
    question: 'How does delivery work?',
    answer:
      "On day of delivery, you'll get a text with an estimated delivery time but you don't need to be in to receive your box. Our insulated boxes will be keep everything fresh for up to 48 hours and your box will be left in your designated safe place.",
  },
  {
    question: "What's in the box?",
    answer:
      "All the pre-portioned ingredients to cook the delicious, healthy recipes you've chosen - all our meat is ethically sourced from small UK farms, fresh fish is sustainably caught and our vegetables are cultivated in the most natural way possible.",
  },
  {
    question: 'Do you offer a guarantee?',
    answer: "If you're not entirely happy, we offer 100% money-back guarantee.",
  },
  {
    question: 'Have a gift voucher?',
    answer:
      'We know we only have one space for vouchers during the sign-up process at this time but donʼt worry, if you have a new customer discount code and a gift voucher to redeem we can make it work! Please sign up using the new customer code. After that just pop an email to hello@mindfulchef.com with your gift voucher code and our customer care team will be happy to then add the gift voucher to your account for you.',
  },
]
